import { Component } from '@angular/core';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppLoaderService } from '../../common/service/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CategoryModule } from '../../appshared/masters/category/category.module';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent {

    public SelectedLanguage: string = "en";
    private sub: any;
    closeModal: any;
    public apiURL: string = "";
    ComID: number = 2;

    constructor(
        public router: Router, private serv: CategoryService, public translate: TranslateService

    ) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }

        if (this.SelectedLanguage == 'ar') {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: true,
            };
        }
        else {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: false,
            };
        }

    }

    Cid: number = 0;
    imgTitle: string = 'assets/img/page-title1.jpg';

    ngOnInit(): void {
        this.FillCategory();
        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';
    }

    datas: any;


    public dataSourceCategory = new MatTableDataSource<CategoryModule>();

    FillCategory() {
        // this.loader.open();
        
        this.serv.getService(this.ComID, 'Category')
            .subscribe((res: CategoryModule[]) => {



                this.dataSourceCategory.data = res;


            },
                (err: any) => {
                    console.log(err);
                });
    }

    onClickCategory(catID: number) {

        this.serv.getServiceParentID(this.ComID, catID, 'Subcategory')
            .subscribe((res: CategoryModule[]) => {


                
                if (res.length > 0) {
                    this.router.navigate(['subcategory', { catID: catID }]);
                }
                else {
                    this.router.navigate(['shop', { scatID: catID }]);
                }


            },
                (err: any) => {
                    console.log(err);
                    this.router.navigate(['shop', { scatID: catID }]);
                });

        
    }


    slideConfig = {
        slidesToShow: 10,
        slidesToScroll: 1,
        autoplay: false,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: '<button class="slick-prev custom-arrow"><i class="bx bx-chevron-left"></i></button>',
        nextArrow: '<button class="slick-next custom-arrow"><i class="bx bx-chevron-right"></i></button>',
        rtl: false,
        centerPadding: '5px',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            }
        ]
    };


    partnerSlidesOptions: OwlOptions = {
        loop: false,
        nav: false,
        dots: false,
        autoplayHoverPause: false,
        autoplay: false,
        margin: 0,
        rtl: true,
        navText: [
            "<i class='bx bx-right-arrow-alt'></i>",
            "<i class='bx bx-left-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 3
            },
            576: {
                items: 4
            },
            768: {
                items:5
            },
            992: {
                items: 6
            }
        }
    }
}
